import ReactDOM from 'react-dom/client';
// bootstrap js
import "primeflex/primeflex.css"
import 'bootstrap/dist/js/bootstrap.bundle';
import "primeicons/primeicons.css"
// Font awesome css
//import 'font-awesome/css/font-awesome.min.css';
import '@fortawesome/fontawesome-free/css/all.css';
import './assets/styles/scss/custom.scss';
//import 'primereact/resources/themes/bootstrap4-light-blue/theme.css'; // Theme
import "primereact/resources/themes/lara-light-indigo/theme.css"; // theme
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store, persistor } from "./redux/store"
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from 'redux-persist/integration/react';



const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(

    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor} >
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </PersistGate>
    </Provider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();
